import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";
import { countIconLineHeight, countIconFontSize } from "../controls/IconView";

export const systemColors = [
  { hex: "#CDE73E" },
  { hex: "#DFD642" },
  { hex: "#4CC749" },
  { hex: "#A4C826" },
  { hex: "#B0B14E" },
  { hex: "#70BB38" },
  { hex: "#019C9E" },
  { hex: "#4BBB9F" },
  { hex: "#D458B5" },
  { hex: "#E671B5" },
  { hex: "#B89BBA" },
  { hex: "#A186BE" },
  { hex: "#00D8CC" },
  { hex: "#7BDFBD" },
  { hex: "#75D1E0" },
  { hex: "#6EC0DF" },
  { hex: "#512DB1" },
  { hex: "#3F51B5" },
  { hex: "#4285F4" },
  { hex: "#03A9F4" },
  { hex: "#7C90DB" },
  { hex: "#77ADEE" },
  { hex: "#8558C9" },
  { hex: "#B371E2" },
  { hex: "#EC4F5D" },
  { hex: "#EC6380" },
  { hex: "#EE533C" },
  { hex: "#F66747" },
  { hex: "#FE7C22" },
  { hex: "#FF9A09" },
  { hex: "#FFB400" },
  { hex: "#FABC00" },
  { hex: "#FFD016" },
  { hex: "#EDCE00" },
  { hex: "#DCBA72" },
  { hex: "#F29A00" },
  { hex: "#666666" },
  { hex: "#888888" },
  { hex: "#AAAAAA" },
  { hex: "#CCCCCC" },
  { hex: "#000", title: "Color_Black" },
  { hex: "#FFFFFF", title: "Color_White" },
  { hex: "transparent" },

  { hex: "#FD5453", title: "R1" },
  { hex: "#DE3E78", title: "R2" },
  { hex: "#C21B45", title: "R3" },
  { hex: "#F13450", title: "R4" },
  { hex: "#FF7D92", title: "R5" },

  { hex: "#FD8942", title: "O1" },
  { hex: "#FC815F", title: "O2" },
  { hex: "#DE520B", title: "O3" },
  { hex: "#F4651D", title: "O4" },
  { hex: "#FF9B21", title: "O5" },

  { hex: "#FFC624", title: "Y1" },
  { hex: "#D8B447", title: "Y2" },
  { hex: "#BA8630", title: "Y3" },
  { hex: "#D98937", title: "Y4" },
  { hex: "#ECB01D", title: "Y5" },

  { hex: "#D2DA4A", title: "G1" },
  { hex: "#32BE6F", title: "G2" },
  { hex: "#1C9638", title: "G3" },
  { hex: "#6EB52A", title: "G4" },
  { hex: "#81D32E", title: "G5" },

  { hex: "#74D7F7", title: "S1" },
  { hex: "#2094CE", title: "S2" },
  { hex: "#25749C", title: "S3" },
  { hex: "#1DAFB1", title: "S4" },
  { hex: "#13CECA", title: "S5" },

  { hex: "#9BC0F2", title: "B1" },
  { hex: "#387DF6", title: "B2" },
  { hex: "#3056C2", title: "B3" },
  { hex: "#5774DC", title: "B4" },
  { hex: "#65A2F6", title: "B5" },

  { hex: "#A08FBA", title: "V1" },
  { hex: "#7C54DA", title: "V2" },
  { hex: "#7933B7", title: "V3" },
  { hex: "#9343AC", title: "V4" },
  { hex: "#B866BD", title: "V5" },

  { hex: "#F0F6FB", title: "N1" },
  { hex: "#D9E4EF", title: "N2" },
  { hex: "#9FB4D0", title: "N3" },
  { hex: "#7E9BC0", title: "N4" },
  { hex: "#435B7B", title: "N5" },
  { hex: "#183864", title: "N6" },
  { hex: "#122B4D", title: "N7" },
];

export const addOpacityToSystemColor = (color: string, opacity: string) => {
  if (color === "transparent") {
    return color;
  }
  opacity = parsePercentToHex(opacity);
  const hexColor = findColor(color);
  return hexColor ? hexColor + opacity : "";
};

export const findColor = (input: string) => {
  if (!input) {
    return null;
  }
  // Sprawdzenie, czy input jest kolorem w formacie szesnastkowym
  const hexPattern = /^#([0-9A-F]{3}){1,2}$/i;

  if (hexPattern.test(input)) {
    // Zwroc w notacji szescioznakowej
    if (input.length === 4) {
      // Skrócony format #RGB
      return `#${input[1]}${input[1]}${input[2]}${input[2]}${input[3]}${input[3]}`;
    }
    return input; // Format #RRGGBB
  }

  // Wyszukaj obiekt z tytulem rownym input
  const found = systemColors.find(
    (color) => color.title === input.toUpperCase(),
  );
  return found ? found.hex : null;
};

const parsePercentToHex = (percent: string) => {
  // Konwersja wartości procentowej na liczbę
  const percentage = parseFloat(percent);

  // Sprawdzenie, czy procent jest liczba w zakresie 0-100
  if (isNaN(percentage) || percentage < 0 || percentage > 100) {
    return "";
  }

  // Przeksztalcenie procentow na wartosc z zakresu 0-255
  const value = Math.round(((100 - percentage) / 100) * 255);

  // Konwersja wartosci na format szesnastkowy
  return value.toString(16).padStart(2, "0").toUpperCase();
};

export class IconTransform extends EldmlTransform {
  apply() {
    this.selector.find("icon").each((_, element) => {
      const icon = $(element);
      let iconName = icon.attr("icon-name");
      let color = icon.attr("color");
      let bgColor = icon.attr("bgcolor");
      let iconSize = icon.attr("size");
      let opacity = icon.attr("bgopacity");
      let valign = icon.attr("valign");
      let borderRadius = icon.attr("border-radius");
      let withBorder = icon.attr("with-border");
      let iconSpan = $(
        '<span class="dataitem-color-icon icon-picker-trigger"></span>',
      );
      if (withBorder) {
        iconSpan.attr("with-border", withBorder);
      }
      if (iconName) {
        iconSpan.addClass(iconName);
      }
      if (color) {
        iconSpan.css("color", color);
        iconSpan.attr("color", color);
      }
      if (valign) {
        iconSpan.attr("valign", valign);
      }
      if (bgColor) {
        if (opacity) {
          const colorWithOpacity = addOpacityToSystemColor(bgColor, opacity);
          iconSpan.css("background-color", colorWithOpacity);
        } else {
          iconSpan.css("background-color", bgColor);
          iconSpan.attr("bgcolor", bgColor);
        }
      }

      if (borderRadius) {
        const borderRadiusValue =
          borderRadius.endsWith("%") || borderRadius.endsWith("px")
            ? borderRadius
            : `${borderRadius}px`;
        iconSpan.css("border-radius", borderRadiusValue);
      }
      const parsedIconSize = iconSize ? parseInt(iconSize) : undefined;
      if (parsedIconSize && !isNaN(parsedIconSize)) {
        let sizePx = iconSize + "px";
        iconSpan.css("width", sizePx);
        iconSpan.css("height", sizePx);
        iconSpan.css("line-height", countIconLineHeight(parsedIconSize)!);
        iconSpan.css("font-size", countIconFontSize(parsedIconSize)!);
      }
      icon.replaceWith(iconSpan);
    });
  }
}
